export class FrtOtoRequest {
  frtOtoRequestId: any;
  requestDateTime: string;
  userId: number;
  organizationId: number;
  queryType: string;
  quoteDateby: string;
  fundingPaAuthority: number;
  expediteFreightShipment: number;
  pickupDate: string;
  pickupTime: string;
  requiredDeliveryDate: string;
  deliveryTime: string;
  declaredShipmentValue: string;
  pocAtPickup: string;
  pocAtPickupPhone: string;
  pocAtPickupEmail: string;
  pickupLocationname: string;
  pickupRestrictions: string;
  pocAtDestination: string;
  pocAtDestinationPhone: string;
  pocAtDestinationEmail: string;
  destinationLocationName: string;
  destinationRestrictions: string;
  originZipId: number;
  destinationZipId: number;
  originCountryId: number;
  destinationCountryId: number;
  estimatedWeight: number;
  estimatedMiles: number;
  estimatedCuFt: number;
  additionalNotes: string;


  /*constructor(requestDateTime: string, userId: number, organizationId: number, queryType: string, quoteDateby: string, fundingPaAuthority: number, expediteFreightShipment: number, pickupDate: string, pickupTime: string, requiredDeliveryDate: string, deliveryTime: string, declaredShipmentValue: string, pocAtPickup: string, pocAtPickupPhone: string, pocAtPickupEmail: string, pickupLocationname: string, pickupRestrictions: string, pocAtDestination: string, pocAtDestinationPhone: string, pocAtDestinationEmail: string, destinationLocationName: string, destinationRestrictions: string, originZipId: number, destinationZipId: number, originCountryId: number, destinationCountryId: number, estimatedWeight: number, estimatedMiles: number, estimatedCuFt: number, additionalNotes: string) {
    this.requestDateTime = requestDateTime;
    this.userId = userId;
    this.organizationId = organizationId;
    this.queryType = queryType;
    this.quoteDateby = quoteDateby;
    this.fundingPaAuthority = fundingPaAuthority;
    this.expediteFreightShipment = expediteFreightShipment;
    this.pickupDate = pickupDate;
    this.pickupTime = pickupTime;
    this.requiredDeliveryDate = requiredDeliveryDate;
    this.deliveryTime = deliveryTime;
    this.declaredShipmentValue = declaredShipmentValue;
    this.pocAtPickup = pocAtPickup;
    this.pocAtPickupPhone = pocAtPickupPhone;
    this.pocAtPickupEmail = pocAtPickupEmail;
    this.pickupLocationname = pickupLocationname;
    this.pickupRestrictions = pickupRestrictions;
    this.pocAtDestination = pocAtDestination;
    this.pocAtDestinationPhone = pocAtDestinationPhone;
    this.pocAtDestinationEmail = pocAtDestinationEmail;
    this.destinationLocationName = destinationLocationName;
    this.destinationRestrictions = destinationRestrictions;
    this.originZipId = originZipId;
    this.destinationZipId = destinationZipId;
    this.originCountryId = originCountryId;
    this.destinationCountryId = destinationCountryId;
    this.estimatedWeight = estimatedWeight;
    this.estimatedMiles = estimatedMiles;
    this.estimatedCuFt = estimatedCuFt;
    this.additionalNotes = additionalNotes;
  }*/
}

